import { httpDelete, httpGet, httpPost, httpPut } from '../../data'
import type {
  ICreateSubscriptionPayload,
  ISubscription,
  ISubscriptionApiResponse,
  IUpdateSubscriptionPayload,
} from '../../../domain/interfaces/ISubscription'

const subscriptionsUrl = '/subscriptions'

/**
 * Get subscriptions with optional query parameters
 * Supports sorting, pagination & queries like roleId, userId
 * Example: subscriptionsGet({ userId: 'id', skip: 0, limit: 10 })
 */
export async function subscriptionsGet(queryString?: string) {
  return await httpGet<ISubscriptionApiResponse>(`${subscriptionsUrl}?${queryString}`, false)
}

/**
 * Get a single subscription by ID
 */
export async function subscriptionsGetOne(id: string) {
  return await httpGet<ISubscription>(`${subscriptionsUrl}/${id}`, true)
}

/**
 * Create a new subscription
 */
export async function subscriptionsPost(data: ICreateSubscriptionPayload) {
  return await httpPost<ISubscription>(subscriptionsUrl, data, {}, true)
}

/**
 * Update an existing subscription
 */
export async function subscriptionsPut(id: string, data: IUpdateSubscriptionPayload) {
  return await httpPut<ISubscription>(`${subscriptionsUrl}/${id}`, data, true)
}

/**
 * Delete a subscription
 */
export async function subscriptionsDelete(id: string) {
  return await httpDelete<ISubscription>(`${subscriptionsUrl}/${id}`, true)
}
